import { makeVar } from '@apollo/client';

const init_state = {
  businessType: '',
  businessTypeValue: '',
  customerFetchRequiredOnLoad: false,
  productType: '',
  productTypeValue: '',
  intermediaryDetails: {
    code: '',
    intermediaryName: '',
    location: '',
    branchOfficeName: '',
    fieldUserCode: '',
    fieldUserName: '',
  },
  isQuoteSaved: false,
  quoteData: null,
  coverData: null,
  quoteNumber: '',
  quoteStatus: '',
  quoteCreationDate: '',
  proposalNumber: '',
  proposalStatus: '',
  isProposalApplicableForPayment: null,
  isPolicyIssued: false,
  existingPolicyNumber: '',
  isExistingEmployee: '',
  proposerDetailsMeta: {
    crn: '',
    isNewCustomer: null,
    ifscCode: '',
    bankName: '',
    branchName: '',
    bankAcno: '',
    accountHolderName: '',
    micrCode: '',
  },
  proposerDetails: {
    id: '',
    customerType: '',
    title: '',
    gender: '',
    firstName: '',
    middleName: '',
    lastName: '',
    fullName: '',
    occupation: '',
    maritalStatus: '',
    nationality: '',
    proposerDOB: '',
    panNumber: '',
    idProofType: '',
    idProofNumber: '',
    permAddressLine1: '',
    permAddressLine2: '',
    permAddressLine3: '',
    permLandmark: '',
    permPincode: '',
    permCityTownVillage: '',
    permDistrict: '',
    permState: '',
    permCommAddressYN: false,
    commAddressLine1: '',
    commAddressLine2: '',
    commAddressLine3: '',
    commLandmark: '',
    commPincode: '',
    commCityTownVillage: '',
    commDistrict: '',
    commState: '',
    mobileNo: '',
    emailID: '',
    orgName: '',
    orgType: '',
    contactName: '',
    regNumber: '',
    tanNumber: '',
    gstNumber: '',
    phoneNo: '',
    altPhoneNo: '',
    altMobileNo: '',
    faxNo: '',
    employeeNumber: '',
  },
  vehicleTabDetails:[],
  additionalTabDetails: {
    previousInsuranceAndClaims: {
      previousPolicyDetails: {
        previousInsurerName: '',
        expiringPolicyNumber: '',
        policyCoverType: '',
        policyStartDate: '',
        policyExpiryDate: '',
        policyTenure: '',
        policyTenureValue: '',
      },
      previousClaims: {
        totalClaimCount: '',
        totalClaimCountValue: '',
        totalClaimAmount: '',
        previousYearNCBSlab: '',
        noOfClaimsYear1: '',
        noOfClaimsYear2: '',
        noOfClaimsYear3: '',
      },
    },
    nomineeDetails: {
      nomineeName: '',
      nomineeDob: '',
      relationshipWithNominee: '',
      nameOfAppointee: '',
      relationshipWithAppointee: '',
    },
    financeDetails: {
      vehicleOwned: '',
      financerDetails: {
        financerName: '',
        financerAddress: '',
        financerAgreementType: '',
        loanAccountNumber: '',
        fileNumber: '',
      },
    },
  },
  reviewAndConfirmTabDetails: {
    proposalPaymentType: '',
    leadGenerator: '',
    isProposalCreated: false,
  },
  policy: {
    startDate: '',
    endDate: '',
    time: '',
  },
  issuedPolicyData: {
    policyNo: '',
    receiptID: [],
    referenceNumber: '',
    digiLink: '',
    displayMessage: '',
    additionalMessage: '',
  },
  premiumData: {
    idv1: '',
    idv2: '',
    idv3: '',
    tenure: '',
    netODPremium: null,
    netTPPremium: null,
    loadingDiscount: null,
    netPremium: null,
    gst: null,
    stampDuty: null,
    totalPremium: null,
    loading: [],
    discount: [],
    vehicleAge: '',
    claimFreeYear: '',
    creditScore: '',
  },
  premiumDetails: {
    termsAndConditions: false,
    paymentMethod: '',
    payerType: '',
    onlinePayment: {
      transactionId: '',
      isTransactionIdVerified: null,
    },
    cdWallet: {
      cdAccountNo: '',
      cdAccountBalance: '',
    },
    cheque: [],
    demandDraft: [],
  },
};

export const buyMotorPolicyVar = makeVar(init_state);

export const initBuyMotorPolicyVar = () => {
  buyMotorPolicyVar(init_state);
};

export const resetProposerDetails = (data) => {
  let initObj = {},
    initMetaObj = {};
  Object.keys(buyMotorPolicyVar().proposerDetails).forEach((v) => {
    if (data?.proposerDetails[v]) {
      initObj[v] = data.proposerDetails[v];
    } else {
      if (v === 'permCommAddressYN') {
        initObj[v] = false;
      } else {
        initObj[v] = '';
      }
    }
  });
  Object.keys(buyMotorPolicyVar().proposerDetailsMeta).forEach(
    (v) => {
      if (data?.proposerDetailsMeta[v]) {
        initMetaObj[v] = data.proposerDetailsMeta[v];
      } else {
        initMetaObj[v] = '';
      }
    },
  );
  buyMotorPolicyVar({
    ...buyMotorPolicyVar(),
    proposerDetails: initObj,
    proposerDetailsMeta: initMetaObj,
  });
};

export const updateBuyMotorPolicy = (data) => {
  let { proposerDetails, proposerDetailsMeta, ...rest } = data;
  if (proposerDetails && proposerDetailsMeta) {
    buyMotorPolicyVar({
      ...buyMotorPolicyVar(),
      proposerDetails: {
        ...buyMotorPolicyVar().proposerDetails,
        ...proposerDetails,
      },
      proposerDetailsMeta: {
        ...buyMotorPolicyVar().proposerDetailsMeta,
        ...proposerDetailsMeta,
      },
      ...rest,
    });
  } else if (proposerDetails && !proposerDetailsMeta) {
    buyMotorPolicyVar({
      ...buyMotorPolicyVar(),
      proposerDetails: {
        ...buyMotorPolicyVar().proposerDetails,
        ...proposerDetails,
      },
      ...rest,
    });
  } else if (!proposerDetails && proposerDetailsMeta) {
    buyMotorPolicyVar({
      ...buyMotorPolicyVar(),
      proposerDetailsMeta: {
        ...buyMotorPolicyVar().proposerDetailsMeta,
        ...proposerDetails,
      },
      ...rest,
    });
  } else {
    //console.log('state rest')
    buyMotorPolicyVar({
      ...buyMotorPolicyVar(),
      ...rest,
    });
  }
};

export const updatePaymentMethod = (data) =>
  buyMotorPolicyVar({
    ...buyMotorPolicyVar(),
    ...data,
  });

export const updateCheque = (data) =>
  buyMotorPolicyVar({
    ...buyMotorPolicyVar(),
    cheque: data,
  });
